import { createSelector, createSlice } from '@reduxjs/toolkit';
import { sortItems } from '@utils/functions.js';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    items: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  blockDesign: {
    layout: '2',
    view: 'feed',
  },
  itemDesign: {},
  containerDesign: {},
  activeItem: {},
};

export const membershipSlice = createSlice({
  name: 'membership',
  initialState,
  reducers: {
    membershipStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      // state.itemDesign = {
      //       //   shape: itemDesign.shape ?? 'round',
      //       //   border: itemDesign.border ?? 'none',
      //       //   borderColor: itemDesign.borderColor ?? '#000000',
      //       //   shadow: itemDesign.shadow ?? 'none',
      //       //   shadowColor: itemDesign.shadowColor ?? '#000000',
      //       // };
      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        items: blockContent.items ?? [],
        heading: {
          title: blockContent.heading.title ?? '',
          description: blockContent.heading.description ?? '',
          textAlign: blockContent.heading.textAlign ?? 'left',
          image: blockContent.heading.image ?? '',
          divider: blockContent.heading.divider ?? '',
          position: blockContent.heading.position ?? '',
        },
      };

      state.blockDesign = {
        layout: String(blockDesign.layout) ?? '2',
        view: blockDesign.view ?? 'feed',
      };
    },
    membershipClear: () => initialState,

    membershipUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    membershipUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    membershipUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    membershipUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
    membershipUpdateActiveItem: (state, action) => {
      state.activeItem = action.payload;
    },
  },
});

export const {
  membershipStore,
  membershipClear,
  membershipUpdateIsLoading,
  membershipUpdateIsActive,
  membershipUpdateBlockContent,
  membershipUpdateBlockDesign,
  membershipUpdateActiveItem,
} = membershipSlice.actions;

export const selectMembershipIsLoading = (state) => state.membership.isLoading;

export const selectMembershipId = (state) => state.membership.id;
export const selectMembershipUID = (state) => state.membership.uid;
export const selectMembershipSID = (state) => state.membership.sid;

export const selectMembershipBlockContent = (state) => state.membership.blockContent;
export const selectMembershipBlockDesign = (state) => state.membership.blockDesign;
export const selectMembershipSortItems = createSelector([selectMembershipBlockContent], ({ items }) => {
  return sortItems(items);
});

export const selectMembershipItemDesign = (state) => state.membership.itemDesign;
export const selectMembershipContainerDesign = (state) => state.membership.containerDesign;

export const selectMembershipActiveItem = (state) => state.membership.activeItem;

export default membershipSlice.reducer;
